import sc from 'styled-components';
import _ from 'lodash';
import c from 'chroma-js';
import { Button } from 'antd';
import { BLUE_DARK, BLACK } from './styleConstants';


const TEXT_SHADOW = `1px 1px 1px ${c(BLACK).alpha(0.5).css()
},0px 0px 1px ${c(BLACK).alpha(0.25).css()})`;
export default sc(Button)`
text-transform: ${({type, textCase}) => {
  if (type === 'link') return 'none';
  return textCase || 'none';
}};
padding: ${(props) => {
    const size = _.get(props, 'size', 'medium');
    switch (size) {
      case 'small':
        return '4px 7px';
        // eslint-disable-next-line no-unreachable
        break;

      default:
        return '0.55rem 1.33rem';
    }
  }};

line-height: 1.25;
height: auto;
border-radius: 4px;
text-align: ${({ align }) => (align || 'center')}
text-shadow: ${({ type }) => {
    let out = '';
    switch (type) {
      case 'danger':
        out = TEXT_SHADOW;
        break;

      case 'primary':
        out = TEXT_SHADOW;
        break;

      default:
        out = '';
    }
    return out;
  }};
border: ${({ type }) => {
    let out = '';
    switch (type) {
      case 'danger':
        out = 'none';
        break;

      case 'primary':
        out = 'none';
        break;

      case 'link':
        out = 'none';
        break;

      default:
        out = `1px solid ${c(BLUE_DARK).alpha(0.125)}`;
    }
    return out;
  }};
  
 &.ant-btn-sm{
  font-size: 12px;
  }
`;
